import React from 'react'
import { motion } from "framer-motion"
import { PaddedContainer, FlexContainer, Heading, ParaText, BlueText, IconContainer } from "../styles/Global.styles"
import { SkillsCardContainer, SkillsCard } from "../styles/Skills.styles"
import { skillsData } from "../utils/Data"
import { fadeInLeft, fadeInRight } from "../utils/MotionVariants"

const Skills = () => {
  return (
    <PaddedContainer
        id="Skills"
        top="10%"
        bottom="10%"
        responsiveTop="20%"
        responsiveBottom="20%"
        responsiveLeft="1rem"
        responsiveRight="1rem"
    >
        <FlexContainer
          responsiveFlex
          fullWidthChild
          responsiveDirection="column-reverse"
        >
            <SkillsCardContainer
              as={motion.div}
              variants={fadeInLeft}
              initial="hidden"
              whileInView="visible"
            >
              {skillsData.map((skill) => (
                <SkillsCard key={skill.id}>
                  <IconContainer size="4rem" color="blue">
                    {skill.icon}
                  </IconContainer>
                  <Heading as="h4" size="h4">{skill.title}</Heading>
                </SkillsCard>
              ))}
            </SkillsCardContainer>
            <motion.div
              variants={fadeInRight}
              initial="hidden"
              whileInView="visible"
            >
              <Heading as="h4" size="h4">Skills</Heading>
              <Heading as="h2" size="h2" top="0.5rem" >What I <BlueText>Can</BlueText> Do</Heading>
              <ParaText top="2rem" bottom="1.5rem">
                As a developer, I have a wide range of skills that I have developed over the years. I have experience with a variety of technologies and tools, including C, C++, Java, HTML, CSS, JavaScript, PHP, React, Express, React Native, MongoDB, and SQL. I am always eager to learn new things and improve my skills, so I constantly work on new projects and explore emerging technologies.
              </ParaText>
              <ParaText>
                I am passionate about web development and enjoy creating beautiful, functional websites that help businesses grow and succeed. I take pride in delivering high-quality work and continuously seek to refine my techniques and methodologies to stay ahead in the ever-evolving tech landscape.
              </ParaText>
            </motion.div>
        </FlexContainer>
    </PaddedContainer>
  )
}

export default Skills
